import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper/bundle";

export default class extends Controller {
  connect() {
    const swiperContainer = this.element.querySelector(".swiper");
    if (!swiperContainer) return;

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 24,
      speed: 500,
      grabCursor: true,
      pagination: {
        el: this.element.querySelector(".mpi-shop-pagination"),
        clickable: true,
        bulletClass: "mpi-shop-dot",
        bulletActiveClass: "active",
      },
      navigation: {
        prevEl: this.element.querySelector(".mpi-shop-arrow-prev"),
        nextEl: this.element.querySelector(".mpi-shop-arrow-next"),
      },
    });
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
